import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";


function Profile({ user, setUser }) {
    const navigate = useNavigate();

    const [orders, setOrders] = useState([]);

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("user"));

        fetch(`https://ecommerce-backend-ya7x.onrender.com/api/orders/${user._id}`)
            .then(res => res.json())
            .then(data => setOrders(data));
    }, []);

    const total = orders.reduce((sum, o) => sum + (o.total || 0), 0);
    const initial = user?.email ? user.email[0].toUpperCase() : "?";

    const handleLogout = () => {
        setUser(null);
        navigate("/");
    };

    return (
        <div className="min-h-screen bg-[#0d0d0f] text-white [font-family:'Syne',sans-serif]">
            <link href="https://fonts.googleapis.com/css2?family=Syne:wght@400;500;600;700&display=swap" rel="stylesheet" />

            <section className="max-w-3xl mx-auto px-4 sm:px-6 py-10">

                {/* Header */}
                <div className="border-b border-white/5 pb-6 mb-6">
                    <p className="text-[0.65rem] font-medium tracking-[0.22em] uppercase text-[#6f5bff] mb-3">
                        Account
                    </p>
                    <h1 className="text-3xl font-semibold tracking-tight">Profile</h1>
                </div>

                {/* User Info */}
                <div className="bg-[#141416] border border-white/[0.07] rounded-[10px] p-4 sm:p-5 mb-4
          hover:border-[#6f5bff]/30 transition-all duration-200">
                    <div className="flex items-center gap-4">

                        {/* Avatar */}
                        <div className="w-12 h-12 rounded-full bg-[#1e1b35] border border-[#6f5bff]/30
              flex items-center justify-center shrink-0">
                            <span className="text-sm font-semibold text-[#8b7dff]">{initial}</span>
                        </div>

                        <div>
                            <h3 className="text-sm font-semibold text-white">
                                {user?.name || user?.email?.split("@")[0] || "User"}
                            </h3>
                            <p className="text-xs text-gray-500 mt-0.5">{user?.email || "—"}</p>
                        </div>

                        <div className="ml-auto flex items-center gap-3">
                            <span className="text-[0.65rem] font-medium tracking-[0.15em] uppercase
                text-[#6f5bff] bg-[#6f5bff]/10 border border-[#6f5bff]/20 px-2.5 py-1 rounded-full">
                                Member
                            </span>
                            <button
                                onClick={handleLogout}
                                className="text-[0.7rem] font-medium text-gray-600 hover:text-red-400 transition-colors duration-200"
                            >
                                Logout
                            </button>
                        </div>
                    </div>
                </div>

                {/* Orders */}
                <div className="bg-[#141416] border border-white/[0.07] rounded-[10px] p-4 sm:p-5">
                    <div className="flex items-center justify-between mb-5">
                        <p className="text-[0.65rem] font-medium tracking-[0.22em] uppercase text-[#6f5bff]">
                            Orders
                        </p>
                        <span className="text-xs text-gray-600">{orders.length} orders</span>
                    </div>

                    {orders.length === 0 ? (
                        <div className="flex flex-col items-center justify-center py-12 gap-2">
                            <svg className="w-8 h-8 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25z" />
                            </svg>
                            <p className="text-gray-600 text-sm">No orders yet</p>
                        </div>
                    ) : (
                        <>
                            <div className="flex flex-col gap-2.5 mb-5">
                                {orders.map((order, i) => (
                                    <div key={i} className="mb-4 border-b border-white/5 pb-3">

                                        {order.products.map((item, j) => (
                                            <div key={j} className="flex justify-between text-sm text-white">
                                                <span>{item.name}</span>
                                                <span>₹{item.price}</span>
                                            </div>
                                        ))}

                                        <p className="text-right text-[#8b7dff] mt-2 font-semibold">
                                            Total: ₹{order.total}
                                        </p>

                                    </div>
                                ))}
                            </div>

                            <div className="flex items-center justify-between pt-3 border-t border-white/5">
                                <span className="text-xs text-gray-500">Total spent</span>
                                <span className="text-sm font-semibold text-white">₹{total}</span>
                            </div>
                        </>
                    )}
                </div>

            </section>
        </div>
    );
}

export default Profile;